import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const usePaymentsDueByPatient = ({
  page = 1,
  rows = 20,
  startDate = null,
  endDate = null,
  sortBy = "latestDueDate",
  sortDirection = "DESC",
  enabled = true,
}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [
      "payments-due-by-patient",
      tenantVal,
      page,
      rows,
      startDate,
      endDate,
      sortBy,
      sortDirection,
    ],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const params = new URLSearchParams();

      params.append("page", page);
      params.append("rows", rows);
      params.append("sortBy", sortBy);
      params.append("sortDirection", sortDirection);

      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const url = `${tenantVal}/consultationpaymentdue/aggregated-by-patient?${params.toString()}`;

      const response = await axiosInstance.get(url);

      return response.data;
    },
    enabled: enabled && !!tenantVal,
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000,
  });
};

export { usePaymentsDueByPatient };
